<template>
	<div class="bg-white px-3 index" >
		<div class="add_tits" ref="titles">
			<el-form class="form-inlines u-f u-jsb" :inline="true">
				<div>
					<!-- <el-form-item label="类型">
						<el-cascader v-model="lb_value" size="small" :props="lb_props" :options="lb_options" clearable>
						</el-cascader>
					</el-form-item>
					<el-form-item label="人员">
						<el-select v-model="search_ry" clearable placeholder="请选择" size="small" filterable>
							<el-option v-for="item in  ry_options" :key="item.id" :label="item.nickname"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="时间">
						<el-date-picker v-model="times" size="small" type="daterange" value-format="yyyy-MM-dd"
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
					</el-form-item>
					<!-- <el-form-item>
						<el-button type="success" icon="el-icon-potato-strips" size="small" :loading='uploading'
							@click="updatelist">更新PC图文页</el-button>
					</el-form-item> -->
				</div>
				<div>
					<el-form-item>
						<el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
						</el-button>
					</el-form-item>
				</div>
			</el-form>
		</div>
		<div class="ibox-content">
			<el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
				<el-table-column prop="id" label="编号" width="80"></el-table-column>
				<!-- <el-table-column prop="create_author_text" label="创作人">
					<template slot-scope="scope">
						<span>{{scope.row.author_text}}</span>
					</template>
				</el-table-column> -->
				<el-table-column prop="name" label="图文标题" show-overflow-tooltip></el-table-column>
				<el-table-column prop="content" label="图文封面">
					<template slot-scope="scope">
						<div class="u-f u-wrap" v-if="scope.row.file">
							<div v-for="(item,index) in scope.row.file" :key="index" @click="goprev(item)">
								<img :src="item.url" alt="" width="50" class="tablimg">
							</div>
						</div>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="sort" label="排序" width="50"></el-table-column> -->
				<el-table-column prop="create_time" label="添加时间" show-overflow-tooltip></el-table-column>
				<!-- <el-table-column prop="is_examine_text" label="状态" show-overflow-tooltip>
					<template slot-scope="scope">
						<span v-if="scope.row.is_examine==0">待审核</span>
						<span v-else-if="scope.row.is_examine==1" style="color:green">审核通过</span>
						<span v-else-if="scope.row.is_examine==2" style="color:red">审核未通过</span>
					</template>
				</el-table-column> -->
				<!-- <el-table-column prop="refuse_remark" label="拒绝理由" show-overflow-tooltip></el-table-column> -->
				<!-- <el-table-column prop="bonus" label="已打赏" width="70"></el-table-column> -->
				<!-- <el-table-column prop="bonus" label="详细" width="85">
					<template slot-scope="{row}">
						<el-button type="text" @click="opxxdateil(row)">详细数据</el-button>
					</template>
				</el-table-column> -->
				<el-table-column label="操作" width="250" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type="info" v-if="scope.row.is_top!=1" @click="handle_top(scope.row,1)">
							置顶
						</el-button>
						<el-button size="mini" type="primary" v-else plain @click="handle_top(scope.row,0)">取消
						</el-button>
						<!-- <el-button size="mini" type="warning" @click="handleexam(scope.$index, scope.row)">审核
						</el-button> -->
						<el-button size="mini" type="primary" icon="el-icon-edit-outline"
							@click="handleEdit(scope.row,scope.$index)"></el-button>
						<!-- <el-button size="mini" type="success" @click="handleComment(scope.$index, scope.row)">评论
						</el-button> -->
						<el-button size="mini" type="danger" icon="el-icon-delete"
							@click="handleDelet(scope.row,scope.$index)"></el-button>
						<!-- <el-button size="mini" type="info" @click="handle_ds(scope.row)" v-if="scope.row.create_user">
							打赏
						</el-button> -->
						<!-- <el-button size="mini" @click="pinglunClick( scope.row)">
							虚拟评论
						</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<div class="u-f u-ac u-jsb ft_mr">
				<div></div>
				<div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper" :total="count">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="图文展示设置" :visible.sync="dialogVisible" center top="20px" width="70%" class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content" v-loading='openeditloading'>
				<el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px"
					class="demo-ruleForm forms-lines">
					<!-- <el-form-item label="人员" prop='ry_value'>
						<el-select v-model="ruleForm.ry_value" clearable placeholder="请选择" size="small" filterable>
							<el-option v-for="item in  ry_options" :key="item.id" :label="item.nickname"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="图文类别" prop='lb_value'>

						<el-cascader v-model="ruleForm.lb_value" size="small" :props="lb_props" :options="lb_options">
						</el-cascader>
					</el-form-item>
					<el-form-item label="图文标题" prop='lb_title'>
						<el-input v-model="ruleForm.lb_title" size="small"></el-input>
					</el-form-item>
					<el-form-item label="关键词">
						<div class="u-f u-ac">
							<el-input v-model="ruleForm.keyword" size="small" placeholder="用顿号分割(、)"></el-input>
							<el-tag type="success">用顿号分割(、)</el-tag>
						</div>
					</el-form-item>
					<el-form-item label="描述">
						<div class="u-f u-ac">
							<el-input v-model="ruleForm.describe" type="textarea" :rows="3" size="small"
								placeholder="文章描述"></el-input>
						</div>
					</el-form-item>
					<el-form-item label="图文封面" required>
						<el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
							:headers="{ token:$store.state.user.token }"
							:data="{ image_class_id:'72',file_type:'1',verification:1,fileS:2,fileH:530,fileW:680 }"
							:file-list="ruleForm.lb_mapList" :on-success="uploadSuccess" :on-remove="uploadRmove"
							list-type="picture-card">
							<i class="el-icon-plus"></i>
							<!-- verification:1,fileS:2,fileH:300,fileW:300  -->
						</el-upload>
					</el-form-item>
					<el-form-item label="图文内容" prop='lb_content'>
						<tinymce ref="editor" v-model="ruleForm.lb_content"
							toolbar="undo redo |  formatselect | bold italic link| alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | imageUpload" />
					</el-form-item>
					<!-- <el-form-item label="免责声明">
						<el-select v-model="ruleForm.lb_state" placeholder="请选择" size="small">
							<el-option v-for="item in state_options" :key="item.id" :label="item.content_name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item> -->
					<!-- <el-form-item label="排序" prop='lb_sort'>
						<el-input v-model="ruleForm.lb_sort" size="small" type="number"> </el-input>
					</el-form-item> -->
					<!-- <div class="u-f u-ac">
						<el-form-item label="基础点赞">
							<el-input v-model="ruleForm.lb_dz" size="small" type="number"> </el-input>
						</el-form-item>
						<el-form-item label="基础浏览">
							<el-input v-model="ruleForm.lb_ll" size="small" type="number"> </el-input>
						</el-form-item>
						<el-form-item label="基础收藏">
							<el-input v-model="ruleForm.lb_sc" size="small" type="number"> </el-input>
						</el-form-item>
					</div> -->
					<!-- <el-form-item label="发布设置" prop='lb_put'>
						<el-radio-group v-model="ruleForm.lb_put">
							<el-radio label="1" style="width:100%;margin-bottom:0px">立即发布</el-radio>
							<div>
								<el-radio label="2">定时发布</el-radio>
								<el-date-picker v-model="ruleForm.lb_dstime" :clearable="false"
									:disabled="ruleForm.lb_put==2?false:true" size="mini" type="datetime"
									value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间" default-time="12:00:00">
								</el-date-picker>
							</div>
							<el-radio label="3" style="width:100%">暂不发布</el-radio>
						</el-radio-group>
					</el-form-item> -->
				</el-form>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
				<el-button @click="dialogVisible = false" size="small">取 消</el-button>
			</span>
		</el-dialog>
		<!--  -->
		<el-dialog :visible.sync="dialog_prev" width="60vw" top="5vh">
			<div style="margin: -60px -20px -30px -20px;">
				<img :src="urls" class="w-100" />
			</div>
		</el-dialog>
		<el-dialog title="评论设置" :visible.sync="dialogs" top="40px" width="70%" center class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<comment ref="coms" :key="commany"></comment>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogs = false" size="small">取 消</el-button>
			</span>
		</el-dialog>
		<el-dialog title="审核" :visible.sync="examdialogs" top="40px" width="70%" center class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<el-form :model="examForm" :rules="rule" ref="examForm" label-width="150px" v-loading='examloading'
					class="demo-ruleForm forms-lines">
					<el-form-item label="标题：">
						<span>{{examForm.name}}</span>
					</el-form-item>
					<el-form-item label="内容：">
						<div class="con_b">
							<span v-html="examForm.content"></span>
						</div>
					</el-form-item>
					<el-form-item label="审核：">
						<el-radio-group v-model="examForm.examradio">
							<el-radio :label="1">审核通过</el-radio>
							<el-radio :label="2">审核不通过</el-radio>
							<el-radio :label="3">分配给</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item v-if="examForm.examradio==2" label="拒绝理由：">
						<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="examForm.remark">
						</el-input>
					</el-form-item>
					<el-form-item v-if="examForm.examradio==3" label="选择：">
						<el-select v-model="examForm.user_value" clearable :filter-method="userFilter" filterable
							placeholder="请选择" size="small">
							<el-option v-for="item in user_options" :key="item.id"
								:label="item.doctorAudit?item.doctorAudit.real_name:item.nickname" :value="item.id">
							</el-option>
						</el-select>
						<el-input type="number" :rows="2" style="max-width:150px;margin-left:10px" size="small"
							placeholder="请输入佣金" v-model="examForm.commission">
						</el-input><span>不选用户则取消分配,不给予佣金则填0</span>
					</el-form-item>
				</el-form>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="examsubmit()" size="small" type="primary" :loading="subloading">提 交</el-button>
				<el-button @click="examdialogs = false" size="small">取 消</el-button>
			</span>
		</el-dialog>

		<el-dialog title="打赏" :visible.sync="dsdialogs" top="150px" width="40%" center class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<el-form :model="dsForm" ref="dsForm" label-width="150px" v-loading='dsloading'
					class="demo-ruleForm forms-lines">
					<el-form-item label="标题：">
						<span>{{dsForm.name}}</span>
					</el-form-item>
					<el-form-item label="创作人：">
						<span>{{dsForm.create_user_text}}</span>
					</el-form-item>
					<el-form-item label="创作时间：">
						<span>{{dsForm.create_time}}</span>
					</el-form-item>
					<el-form-item label="共打赏金额：">
						<span>{{dsForm.bonus}}</span>
					</el-form-item>
					<el-form-item label="打赏：">
						<el-input v-model="ds_mon_value" size="small" style="width:100px" type="number" min="0"
							placeholder="请输入打赏金额">
						</el-input>
					</el-form-item>
				</el-form>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dssubmit()" size="small" type="primary" :loading="subloading">提 交</el-button>
				<el-button @click="dsdialogs = false" size="small">取 消</el-button>
			</span>
		</el-dialog>
		<el-dialog title="详细数据总览" :visible.sync="xxdialogs" top="120px" width="70%" center class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content" v-loading='tableDatadsloading'>
				<el-row>
					<el-col :span="12">
						<div class="ibox-content">
							<el-table :data="tableDatads" border v-loading="loading" :height="heightds"
								class="tableLimit">
								<el-table-column prop="user.nickname" label="打赏人">
									<template slot-scope="{row}">
										<div class="u-f u-ac">
											<div class="ava">
												<el-image style="width: 50px; height: 50px" class="ava_img"
													:src="row.user.avatar" :fit="'cover'">
												</el-image>
											</div>
											<div class="mar_left">{{row.user.nickname}}</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="reward_amount" label="打赏金额"></el-table-column>
								<el-table-column prop="create_time" label="打赏时间"></el-table-column>
							</el-table>

						</div>
					</el-col>
					<el-col :span="12">
						<div class="">
							<el-form :model="xxdatas" ref="xxdatas" label-width="150px" v-loading='dsloading'
								class="demo-ruleForm forms-lines">
								<el-form-item label="浏览量：">
									<span>{{xxdatas.click}}</span>
								</el-form-item>
								<el-form-item label="点赞量：">
									<span>{{xxdatas.praise}}</span>
								</el-form-item>
								<el-form-item label="收藏量：">
									<span>{{xxdatas.collection}}</span>
								</el-form-item>
								<el-form-item label="评论量：">
									<span>{{xxdatas.comment_count}}</span>
								</el-form-item>

							</el-form>
						</div>
					</el-col>
				</el-row>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="xxdialogs = false" size="small">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="虚拟评论" :visible.sync="pldialogs" top="50px" width="60%" center class="dialogs"
			:close-on-click-modal='false'>
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<el-row>
					<el-col :span="12">
						<div class="pl_box" :class="{nullpl_b:pl_length}" v-infinite-scroll="load"
							infinite-scroll-disabled="disabled">
							<div class="item" v-for="(item,index) in pllists" :key="index">
								<div class="info">
									<div class="u-f u-ac">
										<div class="u_ava">
											<el-image style="width: 37px; height: 37px" :src="item.avatar" fit="cover">
											</el-image>
										</div>
										<div class="u_name">{{item.create_user_text?item.create_user_text:'用户'}}
										</div>
									</div>

									<div class="u-f u-ac">
										<!-- <el-rate v-model="item.rating" disabled></el-rate> -->
										<i class="el-icon-delete delbtn" @click="delpl(item,index)"></i>
									</div>
								</div>
								<div class="pl_text">{{item.reply_content}}</div>
								<div class="img_box" v-if="item.file_info&&item.file_info.length>0">
									<el-image style="width: 100px; height: 100px" v-for="(img,ind) in item.file_info"
										:key="ind" :src="img.url" fit="cover" class="pl_img"
										:preview-src-list="[img.url]" :z-index='10000'>
									</el-image>
								</div>
								<div class="time">{{item.create_time}}</div>
							</div>
							<p v-if="plmoreloading" class="pl_load">加载中···</p>
							<div class="nullpl" v-if="pl_length">暂无评论</div>
						</div>
					</el-col>
					<el-col :span="12">
						<el-form :model="plForm" ref="dsForm" label-width="90px" :rules="plrules"
							class="demo-ruleForm forms-lines">
							<el-form-item label="用户：" prop="yh">
								<el-select v-model="plForm.yh" placeholder="请选择" size="small" filterable
									@change="selectUser(plForm.yh)">
									<el-option v-for="item in yh_options" :key="item.id" :label="item.username"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="评论：" prop="reply_content">
								<el-input type="textarea" :rows="6" placeholder="请输入内容" v-model="plForm.reply_content">
								</el-input>
							</el-form-item>
							<el-form-item label="图片：">
								<el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
									:headers="{ token:$store.state.user.token }" :limit="3"
									:data="{ image_class_id:'72',file_type:'1' }" :file-list="plForm.lb_mapList"
									:on-success="uploadSuccesspl" :on-remove="uploadRmovepl" list-type="picture-card">
									<i class="el-icon-plus"></i>
								</el-upload>
							</el-form-item>
						</el-form>
					</el-col>
				</el-row>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="plsubmit('dsForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
				<el-button @click="pldialogs = false" size="small">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	import {
		mapState
	} from 'vuex'
	import tinymce from '@/components/common/tinymce.vue';
	import comment from '@/components/header/comment.vue';
	export default {
		components: {
			tinymce,
			comment
		},
		data() {
			return {
				lb_value: '',
				lb_options: [],
				lb_props: {
					label: "name",
					value: "id",
					children: 'child'
				},
				loading: false,
				tableData: [],
				count: 0,
				currentPage: 1,
				pagesize: 15,
				height: null,
				// 
				eid: '0',
				dialogVisible: false,
				subloading: false,

				ruleForm: {
					lb_title: '',
					lb_value: '',
					lb_content: '',
					lb_sort: 50,
					lb_put: '1',
					lb_dstime: '',
					lb_mapList: [],
					keyword: '',
					lb_state: '',
					ry_value: '',
					lb_dz: '',
					lb_ll: '',
					lb_sc: '',
					describe: '',
				},
				mapListed: [],
				state_options: [],
				ry_options: [],
				rule: {
					lb_value: [{
						required: true,
						message: '请填写图文类别',
						trigger: 'blur'
					}],
					lb_title: [{
						required: true,
						message: '请填写图文标题',
						trigger: 'blur'
					}],

					lb_content: [{
						required: true,
						message: '请填写图文内容',
						trigger: 'blur'
					}],
					lb_sort: [{
						required: true,
						message: '请填写排序',
						trigger: 'blur'
					}],
					lb_put: [{
						required: true,
						message: '请选择发布设置',
						trigger: 'blur'
					}],
				},
				// 
				dialog_prev: false,
				urls: '',
				// 
				dialogs: false,
				commany: 1,
				examdialogs: false,
				examForm: {
					remark: '',
					examradio: '',
					content: '',
					name: '',
					department: [],
					user_value: '',
					commission: 0
				},
				examloading: false,

				dsForm: {},
				dsdialogs: false,
				dsloading: false,
				ds_mon_value: 0,
				openeditloading: false,
				uploading: false,
				search_ry: '',
				times: [],
				depat_options: [],
				allUserList: [],
				user_options: [],
				examdata: '',
				xxdialogs: false,
				heightds: null,
				tableDatadsloading: false,
				tableDatads: [],
				xxdatas: {},
				// 虚拟评论
				plForm: {
					yh: '',
					rating: 5,
					reply_content: '',
					lb_mapList: []
				},
				plrules: {
					yh: [{
						required: true,
						message: '请选择用户',
						trigger: 'blur'
					}],
					reply_content: [{
						required: true,
						message: '请填写内容',
						trigger: 'blur'
					}]
				},
				plloading: false,
				subloading: false,
				pllists: [],
				selectUserdata: '',
				eid: '',
				is_null_pllist: false,
				plpage: 1,
				plmoreloading: false,
				pl_length: false,
				pldialogs: false,
				yh_options: [],
				mapListedpl: [],

			};
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			}),
			disabled() {
				return this.is_null_pllist || this.plmoreloading
			}
		},
		created() {
			if (sessionStorage.getItem('xuniUsers')) {
				this.yh_options = JSON.parse(sessionStorage.getItem('xuniUsers'))
			} else {
				this.getxnUser()
			}
		},
		async mounted() {
			let that = this
			that.getper()
			await this.getuser()
			that.getHeight()
			that.getlbxx()
			that.getstate()
			that.begin()
		},
		methods: {
			getHeight() {
				let that = this
				var titles = that.$refs.titles.offsetHeight
				that.height = window.innerHeight - titles - 200 + 'px'
				that.heightds = window.innerHeight - 400 + 'px'
				window.onresize = () => {
					var titles = that.$refs.titles.offsetHeight
					that.height = window.innerHeight - titles - 200 + 'px'
					that.heightds = window.innerHeight - 400 + 'px'
				}
			},
			async userFilter(query = '') {
				let arr = this.allUserList.filter((item) => {
					return (item.doctorAudit ? item.doctorAudit.real_name.includes(query) : item.nickname
						.includes(query))
				})
				if (arr.length > 100) {
					this.user_options = arr.slice(0, 200)
					// this.user_options = arr
				} else {
					this.user_options = arr
				}
				this.examloading = false
			},
			async getuser() {
				this.allUserList = await JSON.parse(localStorage.getItem('allUserList'))
				await this.userFilter()
			},
			// 搜索
			begin() {
				let that = this
				that.currentPage = 1
				that.pagesize = 15
				that.search()
			},
			search() {
				let that = this
				that.tableData = []
				that.loading = true
				axios.post("/admin/health/list", {
						page: that.currentPage,
						page_count: that.pagesize,
						health_category_id: that.lb_value[that.lb_value.length - 1],
						// health_category_id: 13,
						type: '1',
						start_time: this.times ? this.times[0] : '',
						end_time: this.times ? this.times[1] : '',
						user_id: this.search_ry,
						article_type:2

					}, {
						token: true
					})
					.then(response => {
						that.loading = false
						that.tableData = response.data.data.list
						that.count = response.data.data.totalCount
					})
					.catch(error => {})
			},
			handleSizeChange(val) {
				let that = this
				that.pagesize = val;
				that.search()
			},
			handleCurrentChange(val) {
				let that = this
				that.currentPage = val;
				that.search()
			},
			handleAdd() {
				let that = this
				this.getsj_zx(7, 12)
				that.dialogVisible = true
				that.eid = '0'
				that.form_clear()
			},
			getsj_zx(iStart, iEnd) {
				let num = Math.abs(Math.ceil(Math.random() * (iStart - iEnd))) + iStart
				this.ruleForm.lb_dz = Math.floor(Math.random() * 1000 + 200) - 0
				this.ruleForm.lb_ll = Math.floor(Math.random() * 1000 + 200) - 0
				this.ruleForm.lb_sc = Math.floor(Math.random() * 1000 + 200) - 0
			},
			form_clear() {
				let that = this
				that.ruleForm.lb_title = ''
				that.ruleForm.lb_value = ''
				that.ruleForm.lb_content = ''
				that.ruleForm.lb_put = '1'
				that.ruleForm.lb_dstime = ''
				that.ruleForm.lb_mapList = []
				that.ruleForm.lb_sort = 50
				that.mapListed = []
				that.ruleForm.lb_state = ''
				that.ruleForm.keyword = ''
				this.ruleForm.ry_value = ''
				// this.ruleForm.lb_dz = ''
				// this.ruleForm.lb_ll = ''
				// this.ruleForm.lb_sc = ''
				this.ruleForm.describe = ''
			},
			// 获取人员
			getper() {
				let that = this
				axios
					.post(`/admin/doctorAssistantList`, {}, {
						token: true
					})
					.then(response => {
						that.ry_options = response.data.data
					})
					.catch(error => {})
			},
			submit(formName) {
				let that = this
				var time;
				if (that.ruleForm.lb_put == '1') {
					time = that.gettimes()
				} else if (that.ruleForm.lb_put == '2') {
					time = that.ruleForm.lb_dstime
				} else {
					time = that.ruleForm.lb_put
				}

				that.$refs[formName].validate((valid) => {
					if (valid) {
						if (that.mapListed.length < 1) return that.$message.error('请上传图文封面');
						that.subloading = true
						let urls;
						if (this.eid && this.eid != '0') {
							urls = "/admin/health/update"
						} else {
							urls = "/admin/health/save"
						}
						axios.post(urls, {
								id: that.eid,
								health_category_id: Array.isArray(that.ruleForm.lb_value) ? that.ruleForm
									.lb_value[that.ruleForm.lb_value.length - 1] : that.ruleForm.lb_value,
								name: that.ruleForm.lb_title,
								content: that.ruleForm.lb_content,
								sort: that.ruleForm.lb_sort,
								file: that.mapListed,
								to_show: that.ruleForm.lb_put,
								show_time: time,
								author: this.user.id,
								type: '1',
								keyword: this.ruleForm.keyword,
								statement: that.ruleForm.lb_state,
								create_user: that.ruleForm.ry_value,
								base_browse: that.ruleForm.lb_ll,
								base_praise: that.ruleForm.lb_dz,
								base_collection: that.ruleForm.lb_sc,
								describe: that.ruleForm.describe,
								is_examine: 1,
								article_type:2
							}, {
								token: true
							})
							.then(response => {
								that.subloading = false
								if (response.data.code == '200') {
									that.dialogVisible = false
									that.search()
								} else {
									that.$message.error(response.data.msg);
								}
							})
							.catch(error => {
								that.subloading = true
							})
					} else {
						this.$alert("信息遗漏未填")
						return false;
					}
				});
			},
			// 编辑
			handleEdit(row, index) {
				let that = this
				that.form_clear()
				that.dialogVisible = true
				that.eid = row.id
				this.openeditloading = true
				axios
					.post("/admin/health/read", {
						id: that.eid,
					}, {
						token: true
					})
					.then(response => {
						this.openeditloading = false
						var data = response.data.data
						that.ruleForm.lb_value = data.health_category_id
						that.ruleForm.lb_title = data.name
						that.ruleForm.keyword = data.keyword
						that.ruleForm.lb_content = data.content
						that.ruleForm.lb_mapList = data.file ? data.file : []
						that.mapListed = data.file ? data.file : []
						that.ruleForm.lb_put = data.to_show ? data.to_show.toString() : ''
						if (data.to_show == '2') {
							that.ruleForm.lb_dstime = data.show_time
						}
						that.ruleForm.lb_sort = data.sort
						that.ruleForm.lb_state = data.statement
						that.ruleForm.ry_value = data.create_user ? data.create_user : ''
						that.ruleForm.lb_ll = data.base_browse
						that.ruleForm.lb_dz = data.base_praise
						that.ruleForm.lb_sc = data.base_collection
						that.ruleForm.describe = data.describe
					})
					.catch(error => {})
			},
			// 删除
			handleDelet(row, index) {
				let that = this
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					axios
						.post("/admin/health/del", {
							id: row.id,
						}, {
							token: true
						})
						.then(response => {
							if (response.data.code == '200') {
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
								that.search()
							} else {
								that.$message.error(response.data.msg);
							}
						})
						.catch(error => {})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			gettimes() {
				let nowDate = new Date();
				let year = nowDate.getFullYear();
				let month = nowDate.getMonth() + 1;
				let day = nowDate.getDate();
				let hour = nowDate.getHours(); //获取系统时，
				let min = nowDate.getMinutes(); //分
				let sec = nowDate.getSeconds(); //秒
				month = month > 9 ? month : '0' + month
				day = day > 9 ? day : '0' + day
				hour = hour > 9 ? hour : '0' + hour
				min = min > 9 ? min : '0' + min
				sec = sec > 9 ? sec : '0' + sec
				return `${year}-${month}-${day} ${hour}:${min}`;
			},
			// 类别
			getlbxx() {
				let that = this
				axios
					.post("/admin/healthCategory/categoryHead", {
						noChild: 1
					}, {
						token: true
					})
					.then(response => {
						that.lb_options = response.data.data
					})
					.catch(error => {})
			},
			// 声明
			getstate() {
				let that = this
				axios
					.post("/admin/getContentBySysTypeId", {
						sys_id: 1,
						type_id: 22
					}, {
						token: true
					})
					.then(response => {
						that.state_options = response.data.data
					})
					.catch(error => {})
			},
			goprev(item) {
				let that = this
				that.dialog_prev = true
				that.urls = item.url
			},
			// 
			uploadSuccess(response, file, fileList) {
				let that = this
				if (response.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1)
								}
							});
						}
					})
					that.$alert(response.msg)
					return;
				}
				that.$message({
					message: '上传成功',
					type: 'success'
				});
				that.mapListed.push(response.data)
			},
			uploadRmove(file, fileList) {
				var index = this.mapListed.findIndex(item => item.id == file.id)
				this.mapListed.splice(index, 1)
			},
			// 评论
			handleComment(index, row) {
				let that = this
				that.dialogs = true
				this.commany += 1
				this.$nextTick(() => {
					this.$refs.coms.eid = row.id
					this.$refs.coms.source = 2
					this.$refs.coms.itemxx = row
					this.$refs.coms.getxx()
					this.$refs.coms.getzsxx()
				})
			},
			handleexam(index, row) {
				this.examdialogs = true
				this.eid = row.id
				this.examdata = row
				this.examloading = true
				axios
					.post("/admin/health/read", {
						id: this.eid,
					}, {
						token: true
					})
					.then(response => {
						this.examloading = false
						var data = response.data.data
						this.examForm.name = data.name
						this.examForm.remark = data.refuse_remark
						this.examForm.examradio = data.is_examine
						this.examForm.content = data.content
						this.examForm.user_value = data.Allocation.length > 0 ? data.Allocation[0].approver_id : ''
						this.examForm.commission = data.Allocation.length > 0 ? data.Allocation[0].commission - 0 : 0

					})
					.catch(error => {})
			},
			handle_top(row, val) {
				axios
					.post("/admin/pc/health_headlines/edit_top", {
						id: row.id,
						is_top: val
					}, {
						token: true
					})
					.then(response => {
						if (response.data.code == '200') {
							this.$message({
								type: 'success',
								message: '操作成功!'
							});
							this.search()
						} else {
							this.$message.error(response.data.message);
						}
					})
					.catch(error => {})
			},
			examsubmit() {
				if (this.examForm.examradio == 2 && this.examForm.remark == '') {
					this.$message({
						message: '请输入拒绝理由',
						type: 'warning'
					});
					return
				}

				let params = {}
				let urls = ''
				// if (this.examForm.examradio == 3 && this.examForm.user_value == '') return this.$message.error('请选择审核人员')
				if (this.examForm.examradio == 3 && this.examForm.commission + '' == '') return this.$message.error('佣金必填')

				if (this.examForm.examradio == 3) {
					urls = '/admin/pc/allocation/save'
					params = {
						data_id: this.eid,
						source: 1,
						author_id: this.examdata.create_user,
						approver_id: this.examForm.user_value,
						commission: this.examForm.commission - 0
					}
				}
				if (this.examForm.examradio != 3) {
					urls = '/admin/pc/health_headlines/set_examine'
					params = {
						id: this.eid,
						refuse_remark: this.examForm.remark,
						type: this.examForm.examradio,
						time: 0
					}
				}
				this.examloading = true
				axios
					.post(urls, params, {
						token: true
					})
					.then(response => {
						if (response.data.code == 200) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.examdialogs = false
							this.search()
						} else {
							this.$message({
								message: response.data.msg,
								type: 'warning'
							});
						}
						this.examloading = false
					})
					.catch(error => {})
			},
			handle_ds(item) {
				this.dsForm = item
				this.ds_mon_value = 0
				this.dsdialogs = true

			},
			dssubmit() {
				if (!this.ds_mon_value || this.ds_mon_value <= 0) return this.$message.error('金额必填且必须大于0')
				this.dsloading = true
				axios
					.post("/admin/pc/CapitalDetails/grantBonus", {
						source: 3,
						grantee_id: this.dsForm.create_user,
						grantee_type: this.dsForm.customer_type,
						price: this.ds_mon_value,
						data_id: this.dsForm.id,
					}, {
						token: true
					})
					.then(response => {
						if (response.data.code == 200) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.dsdialogs = false
							this.search()
						} else {
							this.$message({
								message: response.data.msg,
								type: 'warning'
							});
						}
						this.dsloading = false
					})
					.catch(error => {})
			},
			updatelist() {
				let that = this
				this.$confirm('此操作将更新pc端图文页面, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.uploading = true
					axios
						.get("/admin/pc/createStaticHtml?source=1&type=1&page=1&time=0", {
							headers: {
								token: sessionStorage.getItem('token')
							}
						})
						.then(response => {
							if (response.data.code == '200') {
								this.$message({
									type: 'success',
									message: '更新成功!'
								});
							} else {
								that.$message.error(response.data.msg);
							}
							this.uploading = false
						})
						.catch(error => {})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			opxxdateil(r) {
				this.xxdialogs = true
				this.tableDatadsloading = true
				axios
					.post("/admin/pc/health_headlines/articleDetail", {
						id: r.id,
					}, {
						token: true
					})
					.then(response => {
						if (response.data.code == 200) {
							this.tableDatadsloading = false
							this.xxdatas = response.data.data
							this.tableDatads = response.data.data.RewardRecord

						}
					})
					.catch(error => {})
			},
			getxnUser() {
				this.axios
					.post(
						"/admin/h5/fictitiousUsers", {
							page: 1,
							page_count: 3000
						}, {
							token: true
						}
					)
					.then((res) => {
						this.yh_options = res.data.data.list
						sessionStorage.setItem('xuniUsers', JSON.stringify(res.data.data.list))
					})
					.catch((err) => {

					});
			},
			async pinglunClick(row) {
				this.eid = row.id
				this.plForm.yh = ''
				this.plForm.rating = 5
				this.plForm.reply_content = ''
				this.plForm.lb_mapList = []
				this.mapListedpl = []
				this.pllists = []
				this.pldialogs = true
				this.plpage = 1
				this.plmoreloading = false
				this.is_null_pllist = false
				await this.getpllist()
			},
			load() {
				this.getpllist()
			},
			async getpllist() {
				this.pl_length = false
				this.plmoreloading = true
				await this.axios
					.post(
						"/admin/AllComment/HgetComments", {
							data_id: this.eid,
							source: 2,
							page: this.plpage,
							page_count: 15
						}, {
							token: true
						}
					)
					.then((res) => {
						let data = res.data.data.list
						if (data.length > 0) {
							this.pllists = this.pllists.concat(data)
							this.plpage++
						} else {
							this.is_null_pllist = true
						}
						this.plmoreloading = false
						this.plloading = false
						if (this.pllists.length == 0) {
							this.pl_length = true
						}

					})
					.catch((err) => {

					});
			},
			uploadSuccesspl(response, file, fileList) {
				let that = this
				if (response.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1)
								}
							});
						}
					})
					that.$alert(response.msg)
					return;
				}
				that.$message({
					message: '上传成功',
					type: 'success'
				});
				that.mapListedpl.push(response.data)
			},
			uploadRmovepl(file, fileList) {
				var index = this.mapListedpl.findIndex(item => item.id == file.id)
				this.mapListedpl.splice(index, 1)
			},
			selectUser(val) {
				this.yh_options.forEach(e => {
					if (e.id == val) {
						this.selectUserdata = e
					}
				})
			},
			plsubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.subloading = true
						this.axios
							.post(
								"/admin/AllComment/Hsave", {
									create_user: this.selectUserdata.id,
									author: this.selectUserdata.id,
									data_id: this.eid,
									reply_content: this.plForm.reply_content,
									create_user_text: this.selectUserdata.username,
									avatar: this.selectUserdata.avatar,
									source: 2,
									is_fictitious_user: 1,
									rating: this.plForm.rating,
									file_info: this.mapListedpl,
								}, {
									token: true
								}
							)
							.then((res) => {
								if (res.data.code == 200) {
									this.$message.success('评论成功！')
									this.plpage = 1
									this.pllists = []
									this.getpllist()

								} else {
									this.$message.error(res.data.msg)

								}
								this.subloading = false

							})
							.catch((err) => {

							});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			delpl(item, index) {
				this.$confirm('确认删除此评论, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.axios
						.post(
							"/admin/AllComment/Hdel", {
								id: item.id,
							}, {
								token: true
							}
						)
						.then((res) => {
							if (res.data.code == 200) {
								this.$message.success('评论删除成功！')
								this.pllists.splice(index, 1)
								if (this.pllists.length == 0) {
									this.pl_length = true
								}
							} else {
								this.$message(res.data.msg)
							}
						})
						.catch((err) => {});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			}

		},
		watch: {
			'examForm.examradio'(val, old) {
				if (val == 1) {
					this.examForm.remark = ''
				}
			}
		}

	};
</script>


<style lang='scss'>
	.el-form-item {
		margin-bottom: 22px !important;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.tablimg {
		margin: 2px 5px;
	}

	.con_b {
		height: 500px;
		overflow-x: auto;
		border: 1px solid rgb(206, 206, 206);
		border-radius: 5px;
	}

	.ava {
		border-radius: 50%;
		overflow: hidden;
		margin-right: 5px;

		.el-image {
			display: block;
		}
	}

	.pl_box {
		border: 1px solid rgb(247, 247, 247);
		border-radius: 5px;
		// box-shadow: 0 0 3px 0 rgba($color: #000000, $alpha: .1);
		height: 600px;
		overflow: auto;
		padding: 10px;

		.item {
			.info {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.u_ava {
					border-radius: 50%;
					overflow: hidden;

					.el-image {
						display: block;
					}
				}

				.u_name {
					margin-left: 5px;
				}

				.delbtn {
					color: red;
					cursor: pointer;
					font-size: 16px;
				}
			}

			.pl_text {
				padding: 5px 0;
			}

			.img_box {
				.pl_img {
					margin-right: 5px;
				}
			}

			.time {
				font-size: 12px;
			}
		}

		.pl_load {
			text-align: center;
			font-size: 14px;
		}
	}

	.nullpl_b {
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>